/* eslint-disable max-len */
export const detailsAreaMockedData = {
  "collections": [
    {
      "thumbnail": "https://media.cgtrader.com/variants/6xgsQPfq4Wm3WC5h8Lus2YBW/0614d84bdc59a9966ecae828cdf598d52b24aff775161cff6edd2989d8b52400/thumbnail1.jpg",
      "id": 4112932,
      "title": "Atlantic Ocean Cliff Coast Line Scan PBR",
      "itemsCount": 13,
      "saleOffDiscount": 50,
      "collectionPrice": 120,
      "url": "/3d-model-collections/atlantic-ocean-cliff-coast-line-scan-pbr",
    },
  ],
  "details": {
    "animated": false,
    "rigged": false,
    "game_ready": false,
    "pbr": true,
    "textures": true,
    "materials": true,
    "uv_mapping": true,
    "plugins_used": false,
  },
  "publishDate": "2019-01-07",
  "id": 1865888,
  "geometryType": "Polygon mesh",
  "polygons": 223649,
  "vertices": 228424,
  "cgtVerificationData": {
    "reportType": "cgt_standard",
    "data": {
      "files": {
        "fbxFormat": {
          "pass": true,
        },
      },
      "scene": {
        "dccObjectTypes": {
          "pass": true,
        },
      },
      "geometry": {
        "noNgons": {
          "pass": false,
        },
        "facetedGeometry": {
          "pass": true,
        },
        "nonManifoldVertices": {
          "pass": false,
        },
      },
      "texturesAndMaterials": {
        "missingRequiredTextures": {
          "pass": true,
        },
        "embeddedTexturesFbx": {
          "pass": true,
        },
        "textureAspectRatio": {
          "pass": true,
        },
        "textureResolutionNotPowerOf2": {
          "pass": true,
        },
        "numberOfMaterialsPerObject": {
          "pass": true,
        },
      },
      "uV": {
        "overlappedUvPerUVIsland": {
          "pass": false,
        },
        "numberOfUVs": {
          "pass": true,
        },
      },
      "naming": {
        "allowedCharacters": {
          "pass": false,
        },
      },
    },
    "score": 69,
  },
  "nativeFormats": [
    {
      "title": "BLEND",
      "extensionPath": "/3d-models/ext/blend",
      "fileSize": "247 MB",
      "fileCount": 1,
      "version": "4.2",
      "rendererName": "Default",
      "rendererVersion": null,
      "itemFileVersions": [
        {
          "version": "4.2",
          "rendererName": "Default",
          "rendererVersion": null,
        },
      ],
    },
  ],
  "exchangeFormats": [
    {
      "title": "OBJ",
      "extensionPath": "/3d-models/ext/obj",
      "fileSize": "33.7 MB",
      "fileCount": 1,
      "version": null,
      "rendererName": null,
      "rendererVersion": null,
    },
    {
      "title": "FBX",
      "extensionPath": "/3d-models/ext/fbx",
      "fileSize": "13.6 MB",
      "fileCount": 1,
      "version": null,
      "rendererName": null,
      "rendererVersion": null,
    },
    {
      "title": "MAX",
      "extensionPath": "/3d-models/ext/max",
      "fileSize": "339 MB",
      "fileCount": 2,
      "version": "2014",
      "rendererName": "Corona",
      "rendererVersion": null,
      "itemFileVersions": [
        {
          "version": "2014",
          "rendererName": "Corona",
          "rendererVersion": "3",
        },
        {
          "version": "2014",
          "rendererName": "V-Ray",
          "rendererVersion": "3",
        },
      ],
    },
    {
      "title": "C4D",
      "extensionPath": "/3d-models/ext/c4d",
      "fileSize": "484 MB",
      "fileCount": 1,
      "version": null,
      "rendererName": null,
      "rendererVersion": null,
    },
    {
      "title": "ABC",
      "extensionPath": "/3d-models/ext/abc",
      "fileSize": "22 MB",
      "fileCount": 1,
      "version": null,
      "rendererName": null,
      "rendererVersion": null,
    },
    {
      "title": "TEXTURES",
      "extensionPath": null,
      "fileSize": "260 MB",
      "fileCount": 5,
      "version": null,
      "rendererName": null,
      "rendererVersion": null,
    },
    {
      "title": "OTHER",
      "extensionPath": null,
      "fileSize": "260 MB",
      "fileCount": 3,
      "version": null,
      "rendererName": null,
      "rendererVersion": null,
    },
  ],
  "ungroupedFormats": null,
  "printModelVerificationData": null,
  "summaryFileExtensions": {
    "obj": "1/1",
    "fbx": "1/1",
    "max": "0/1",
    "c4d": "1/1",
    "abc": "0/1",
    "animated": "1/1",
    "rigged": "1/1",
    "low-poly": "0/1",
    "pbr": "0/1",
    "print_ready": "0/1",
  },
  "units": null,
  "locale": "en",
}

export const detailsAreaPrintableMockedData = {
  "collections": [
    {
      "thumbnail": "https://media.cgtrader.com/variants/6xgsQPfq4Wm3WC5h8Lus2YBW/0614d84bdc59a9966ecae828cdf598d52b24aff775161cff6edd2989d8b52400/thumbnail1.jpg",
      "id": 4112932,
      "title": "Atlantic Ocean Cliff Coast Line Scan PBR",
      "itemsCount": 13,
      "saleOffDiscount": 50,
      "collectionPrice": 120,
      "url": "/3d-model-collections/atlantic-ocean-cliff-coast-line-scan-pbr",
    },
  ],
  "details": {
    "animated": false,
    "rigged": false,
    "game_ready": false,
    "pbr": false,
    "textures": false,
    "materials": false,
    "uv_mapping": false,
    "plugins_used": false,
  },
  "publishDate": "2019-07-02",
  "id": 1993387,
  "geometryType": "Subdivision ready",
  "polygons": 0,
  "vertices": 0,
  "cgtVerificationData": {
    "reportType": "3d_print_standard",
    "data": {
      "geometry": {
        "nonManifoldVertices": {
          "pass": false,
        },
        "openEdges": {
          "pass": false,
        },
        "noBadContiguousEdges": {
          "pass": true,
        },
        "noNgons": {
          "pass": true,
        },
        "noSelfIntersections": {
          "pass": false,
        },
        "nonManifoldFaces": {
          "pass": false,
        },
        "overlappingFaces": {
          "pass": false,
        },
        "zeroAngleFaceCorners": {
          "pass": false,
        },
        "zeroLengthEdge": {
          "pass": true,
        },
        "zeroFaceArea": {
          "pass": true,
        },
      },
      "scene": {
        "centeredGeometryBoundingBox": {
          "pass": false,
        },
      },
      "details": {
        "volume": 1559,
        "boundingBoxX": 35.0035,
        "boundingBoxY": 35.001,
        "boundingBoxZ": 2.58548,
        "tooThinWallsCount": 35747,
        "minimalAllowedThickness": 0.2,
      },
    },
    "score": 36,
  },
  "nativeFormats": null,
  "exchangeFormats": null,
  "ungroupedFormats": [
    {
      "title": "STL",
      "extensionPath": "/3d-models/ext/stl",
      "fileSize": "131 MB",
      "fileCount": 1,
      "version": null,
      "rendererName": null,
      "rendererVersion": null,
    },
    {
      "title": "OBJ",
      "extensionPath": "/3d-models/ext/obj",
      "fileSize": "925 MB",
      "fileCount": 1,
      "version": null,
      "rendererName": null,
      "rendererVersion": null,
    },
    {
      "title": "FBX",
      "extensionPath": "/3d-models/ext/fbx",
      "fileSize": "331 MB",
      "fileCount": 1,
      "version": null,
      "rendererName": null,
      "rendererVersion": null,
    },
  ],
  "printModelVerificationData": {
    "cleanGeometry": {
      "manifoldGeometry": false,
      "noSelfIntersections": false,
      "noOverlappingFaces": false,
      "noZeroAngledCorners": false,
      "noZeroLengthEdges": true,
      "noZeroAreaFaces": true,
      "noBadContiguousEdges": true,
      "noOpenEdges": true,
    },
    "score": 50,
  },
  "units": "mm",
  "isPreSupported": true,
  "isSplitIntoMultipleParts": true,
  "multiplePartsDetails": {
    "numberOfParts": "3",
    "unit": "centimeters",
    "width": "120",
    "depth": "60",
    "height": "45",
    "assemblyInstructions": "Dry fit the pieces before final assembly. Apply glue to tenons and clamp for 12 hours."
  },
  "locale": "en",
}
